import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import Paper from '@material-ui/core/Paper';
import {
  Chart,
  PieSeries,
  Title,
  Legend,
  Tooltip,
} from '@devexpress/dx-react-chart-material-ui';
import { Animation, EventTracker } from '@devexpress/dx-react-chart';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Chip from '@material-ui/core/Chip';
import { StatusDistributionSkeleton } from './SkeletonComponents';

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    height: '100%',
  },
  statsContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
    marginTop: theme.spacing(2),
    justifyContent: 'center',
  },
  chip: {
    fontWeight: 'bold',
  },
}));

const StatusDistributionChart = ({ title, data, totalLabel }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  if (!data) {
    return <StatusDistributionSkeleton />;
  }

  if (data.length === 0) {
    return (
      <Paper className={classes.paper}>
        <Typography variant="h6" align="center">
          {title}
        </Typography>
        <Typography variant="body2" align="center" color="textSecondary">
          {t('dashboard.no_data')}
        </Typography>
      </Paper>
    );
  }

  const chartData = data.map(item => ({
    status: t(`status.${item.status}`) || item.status,
    count: item.count,
    percent: item.percent,
    color: item.color,
  }));

  const total = data.reduce((sum, item) => sum + item.count, 0);

  return (
    <Paper className={classes.paper}>
      <Chart data={chartData}>
        <PieSeries
          valueField="count"
          argumentField="status"
          innerRadius={0.5}
          colorField="color"
        />
        <Title text={title} />
        <Legend position="bottom" />
        <Animation />
        <EventTracker />
        <Tooltip />
      </Chart>
      <Box className={classes.statsContainer}>
        <Chip
          label={`${totalLabel}: ${total}`}
          color="primary"
          className={classes.chip}
        />
        {data.map((item) => (
          <Chip
            key={item.status}
            label={`${t(`status.${item.status}`)}: ${item.count} (${item.percent}%)`}
            style={{
              backgroundColor: item.color,
              color: '#fff',
            }}
            size="small"
          />
        ))}
      </Box>
    </Paper>
  );
};

export default StatusDistributionChart;
